const InputField = ({
  type,
  label,
  placeholder,
  error,
  children,
  value,
  setValue,
}) => {
  return (
    <div className="xl:mb-4">
      <label
        htmlFor={label}
        className="block mb-1 xl:mb-3 text-sm font-semibold"
      >
        {label}
      </label>

      <div className="relative mb-3">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center gap-1 pl-3 pointer-events-none text-gray-500 dark:text-gray-400 text-sm">
            {children}
          </div>
          <input
            type={type ? "text" : type}
            id={label}
            maxLength={type === "number" ? 9 : 25}
            pattern={type === "number" ? "[1-9]*" : "*"}
            className={`bg-[#fff] border border-[#D0D5DD] focus:outline-none focus-within:bg-white focus:border-defaultGreen dark:focus:border-defaultGreen  text-sm rounded-lg  block w-full ${
              type === "number" && "pl-20"
            } p-2.5  dark:bg-[#3D404B] dark:border-[#59607A]  dark:placeholder-gray-400 dark:text-defaultTextColor`}
            placeholder={placeholder}
            value={value}
            onChange={setValue}
          />
        </div>
        {error && (
          <p className="absolute left-0 -bottom-4 text-xs text-red-600 dark:text-red-500">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default InputField;
